import styled from '@emotion/styled';

export const Icon = styled.div`
  display: inline-block;
  width: 10px;
  float: left;
`;
